export const env = {
  BASE_URL_API: `${process.env.REACT_APP_BASE_URL_API}/api`,
  BASE_URL_API_PAY: `${process.env.REACT_APP_BASE_URL_API_PAY}/api`,
  BASE_URL_API_INVENTORIES: `${process.env.REACT_APP_BASE_URL_API_INVENTORIES}/api`,
};
